import * as  mixpanel from 'mixpanel-browser';
import { APPLICATION_NAME } from '../constants';
import { mixpanelToken  } from '../configs';
mixpanel.init(mixpanelToken);

export const initialize = (sessionId: string, releaseVersion: string) => {
  mixpanel.register({
    SessionId: sessionId,
    ApplicationName: APPLICATION_NAME,
    ReleaseVersion: releaseVersion,
  });
};

export const track = (type: string, properties?: {}) => {
  const promise = new Promise((resolve, reject) => {
    mixpanel.track(type, properties, (status: any, data: any) => {
      if (status === 0) {
        reject(data);
      } else {
        resolve(data);
      }
    });
  });
  return promise;
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/clients/mixpanelClient.ts